import { RegisterFunctions } from "@repo/database";
import { VisuallyHidden } from "react-aria";
import { useTranslation } from "react-i18next";

import { useMediaQuery } from "~/hooks/use-media-query";
import { useFunctionManager } from "~/managers/use-function-manager";
import { usePermissionManager } from "~/managers/use-permission-manager";
import { useEmployeeStore } from "~/stores/use-employee-store";
import { useRegisterStore } from "~/stores/use-register-store";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "../ui/drawer";
import { RegisterButton } from "../ui/register-button";
import { ScrollArea } from "../ui/scroll-area";

export default function EmployeeProfile() {
  const { logout } = usePermissionManager();

  const { profileOpen, setProfileOpen, selectedEmployee } = useEmployeeStore();

  const { t } = useTranslation("common");

  const { getFunction } = useFunctionManager();

  const { setEndDayOpen } = useRegisterStore();

  const isMobile = useMediaQuery(768);

  const handleLogout = () => {
    logout();
    setProfileOpen(false);
  };

  const handleEndDay = () => {
    setEndDayOpen(true);
    setProfileOpen(false);
  };

  return (
    <>
      {isMobile && (
        <Drawer open={profileOpen} onOpenChange={setProfileOpen}>
          <DrawerContent>
            <DrawerHeader
              showClose={true}
              onClose={() => setProfileOpen(false)}
            >
              <DrawerTitle>
                {selectedEmployee
                  ? selectedEmployee.firstName
                  : t("Employee.profile")}
              </DrawerTitle>
              <VisuallyHidden>
                <DrawerDescription></DrawerDescription>
              </VisuallyHidden>
            </DrawerHeader>
            <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
              <div className="flex flex-col gap-2">
                <RegisterButton>End shift</RegisterButton>
                <RegisterButton
                  onClick={getFunction(RegisterFunctions.end_day)}
                >
                  {t("end_day")}
                </RegisterButton>
                <RegisterButton onClick={handleLogout} variant="destructive">
                  {t("Employee.logout")}
                </RegisterButton>
              </div>
            </div>
            <span className="text-muted-foreground text-center text-xs pb-2">{`v.${APP_VERSION}`}</span>
          </DrawerContent>
        </Drawer>
      )}
      {!isMobile && (
        <Dialog open={profileOpen} onOpenChange={setProfileOpen}>
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle>
                {selectedEmployee
                  ? selectedEmployee.firstName
                  : t("Employee.profile")}
              </DialogTitle>
              <VisuallyHidden>
                <DialogDescription></DialogDescription>
              </VisuallyHidden>
            </DialogHeader>
            <ScrollArea className="max-h-[80vh] p-4">
              <div className="flex flex-col gap-2">
                <RegisterButton>End shift</RegisterButton>
                <RegisterButton onClick={handleEndDay}>End day</RegisterButton>
                <RegisterButton onClick={handleLogout} variant="destructive">
                  {t("Employee.logout")}
                </RegisterButton>
              </div>
            </ScrollArea>
            <span className="text-muted-foreground text-center text-xs pb-2">{`v.${APP_VERSION}`}</span>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
